// extracted by mini-css-extract-plugin
export default {"display":"Display-module_display__tITBuk","hidden":"Display-module_hidden__ph9vvI"};